// @ts-strict-ignore
export abstract class Resource {
  private m_resourceId: string;
  private m_resourceType: string;

  constructor(resourceType: string = undefined, resourceId: string = undefined) {
    this.m_resourceType = resourceType;
    try {
      this.m_resourceId = this.isResourceIdEncoded(resourceId) ? decodeURIComponent(resourceId) : resourceId;
    } catch (e) {
      this.m_resourceId = resourceId || null;
    }
  }

  private isResourceIdEncoded(resourceId: string): boolean {
    if (resourceId) {
      const regEx = /(%2c|%2C|%3a|%3A|%7c|%7C|%5b|%5B|%5d|%5D|%28|%29)/g;
      let matches = resourceId.match(regEx);
      if (matches && matches.length > 0) {
        // If resource if has one of the delimiter ',' or '|' or ':' or view key name
        return true;
      }

      matches = resourceId.match(/(%)/g);
      if (matches && matches.length > 0) {
        // Only one key in the resource id.
        // If we have a resourceId like TaxCode(%10) and it is not encoded, the decode will alter the value.
        // If it is encoded we will have TaxCode(%2510).
        // The challenge is to check if the string is encoded.
        return true;
      }
    }

    return false;
  }

  public get resourceId(): string {
    return this.m_resourceId;
  }

  public set resourceId(resourceId: string) {
    this.m_resourceId = resourceId;
  }

  public get resourceType(): string {
    return this.m_resourceType;
  }

  public set resourceType(resourceType: string) {
    this.m_resourceType = resourceType;
  }

  public abstract generateResourceId(encode: boolean): string;
}
